import style from "./result.module.css";
import Header from "../../components/header/Header";
import Card from "../../components/DiscountCard/Card";
import ProductSlide from "../../components/products/slider/ProductSlide";
import Button from "../../components/button/Button";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
import FooterCo from "../../components/footer/FooterCo";
import BanicoinCard from "../../components/DiscountCard/BanicoinCard/BanicoinCard";
import { configBrandsType } from "../../types/brands";
import BrandItems from "../../components/brands/BrandsItems/BrandItems";
import PS5Badge from "../../components/PS5Badge/PS5Badge";
const ResultPage = () => {
  const dispatch = useAppDispatch();
  const coupon = useAppSelector((state) => state.game.sendScore);
  const products = useAppSelector(
    (state) => state.products.products.data?.data.data
  );
  const { selectedCategory } = useAppSelector((state) => state.categories);
  const chance = useAppSelector((state) => state.game.chnace);
  const specialChance = useAppSelector((state) => state.game.special_chance);
  const handelNextChance = function () {
    if (chance !== 0 || specialChance !== 0) {
      dispatch(configAction.setGameStep(GameStep.CATEGORY));
    } else {
      dispatch(configAction.setGameStep(GameStep.CHANCE));
    }
  };
  const isBanicoin = coupon.data?.data.coupon.type === "banicoin";
  const brands = useAppSelector(
    (state) => state.brands.brands.data?.data.components
  );
  const awardBrands = brands?.find((item) => {
    const config = JSON.parse(item.config!) as configBrandsType;
    return config.type === selectedCategory?.category;
  });
  
  return (
    <div className={style.result}>
      <Header chance title="مبارکت باشه🎉" result />
      <div className={style.inner}>
        <div className={`${style.congrate} desktop`}>
          <span>مبارکت باشه🎉</span>
        </div>
        <div className={`${style.card} fade-in-1`}>
          {isBanicoin ? (
            <BanicoinCard {...coupon.data?.data.coupon!} />
          ) : (
            <Card {...coupon.data?.data.coupon!} />
          )}
          <PS5Badge
            badgeClassname={style.badge}
            innerClassname={style.bagdeInner}
            text="کد تخفیفی که برنده شدی + تخفیف‌های روی سایت"
          />
        </div>
        <div className={`${style.button} slide-bottom `}>
          <Button text="شانس بعدی" onclick={handelNextChance} />
        </div>
        {!!coupon.data?.data.coupon.is_extra ? (
          <BrandItems
            title="برندهای پیشنهادی"
            brands={awardBrands?.attributes?.src_sets.value!}
            className="max-w-[500px]"
            isLink
          />
        ) : (
          !!products?.length && (
            <div className={style.product}>
              <div className={style["product-title"]}>
                <span>محصولات پیشنهادی</span>
              </div>
              <ProductSlide />
            </div>
          )
        )}
      </div>
    </div>
  );
};
export default ResultPage;
